import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { UserGridContainer } from '../../containers/assignEntities/UserGridContainer';
import { SiteGroupGridContainer } from '../../containers/assignEntities/SiteGroupGridContainer';

const AssignUserToSiteGroups = props => {
  const {
    allUsersData,
    loadingAllUsers,
    allSitesData,
    siteGroupData,
    loadingSiteGroup,
    setIsReadOnlyState,
    isReadOnly,
    onResetPageOnDataChange,
    onFilteredChange,
    rightSideGridReactTableRef,
    isRightGridFiltered,
    direction,
    resetGridPage,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={8}>
          <Field
            component={UserGridContainer}
            name={AssignEntitiesEnum.UserGridInfo}
            {...{
              dataSource: allUsersData,
              loadingAllUsers,
              isLeftSideUserGrid: true,
              isRightSideSiteGroupGrid: true,
              allSitesData,
              setIsReadOnlyState,
              isReadOnly,
              onResetPageOnDataChange,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <Field
            component={SiteGroupGridContainer}
            name={AssignEntitiesEnum.SiteGroupGridInfo}
            {...{
              dataSource: siteGroupData,
              loadingSiteGroup,
              isLeftSideUserGrid: true,
              isRightSideSiteGroupGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignUserToSiteGroups.propTypes = {
  allUsersData: PropTypes.array.isRequired,
  allSitesData: PropTypes.array.isRequired,
  siteGroupData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllUsers: PropTypes.bool,
  loadingSiteGroup: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  isRightGridFiltered: PropTypes.bool,
};

AssignUserToSiteGroups.defaultProps = {
  loadingAllUsers: false,
  loadingSiteGroup: false,
  isReadOnly: true,
  direction: true,
  isRightGridFiltered: false,
  rightSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  onResetPageOnDataChange: () => {},
  onFilteredChange: () => {},
};

export default AssignUserToSiteGroups;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignUserToSiteGroups.js